// extracted by mini-css-extract-plugin
export default {"Wrapper":"FAQ_Wrapper__tn5nO","Row":"FAQ_Row__jCvgF","Left":"FAQ_Left__mmVGZ","Right":"FAQ_Right__lyc6x"};